/* istanbul ignore file */

import { createAction, createReducer } from '@reduxjs/toolkit';
import { ENUM_THEME, STORAGE_THEME_FAS } from 'utils/consts';

const INITIAL_STATE = {
  changeLibras: false,
  theme: localStorage.getItem(STORAGE_THEME_FAS) || ENUM_THEME.LIGHT,
  statusLoading: false,
  statusLoadingGrid: false,
  alertApp: { tipo: false, mensagem: false },
  modal: { isOpen: false, title: '' },
  modalJustificativa: { isOpen: false, title: '' },
  modalEncaminhar: { isOpen: false, title: '' },
  modalAcessoNegado: { isOpen: false, title: '' },
  modalUsuarioPendente: { isOpen: false, title: '' },
  modalCor: { isOpen: false, title: '' },
  captcha: { reload: false },
  unitaryTests: false,
  dadosMinimizados: {
    justificativa: '',
    arquivos: null,
    nameModal: null,
    setorEncaminharId: null,
    atendenteEncaminharId: null,
  },
};

export const duckChangeLibras = createAction('DUCK_CHANGE_LIBRAS');
export const duckTheme = createAction('DUCK_THEME');
export const duckStatusLoading = createAction('DUCK_STATUS_LOADING');
export const duckStatusLoadingGrid = createAction('DUCK_STATUS_LOADING_GRID');
export const duckAlertApp = createAction('DUCK_ALERT_APP');
export const duckOpenModal = createAction('DUCK_OPEN_MODAL');
export const duckOpenModalJustificativa = createAction('DUCK_OPEN_MODAL_JUSTIFICATIVA');
export const duckOpenModalEncaminhar = createAction('DUCK_OPEN_MODAL_ENCAMINHAR');
export const duckOpenModalAcessoNegado = createAction('DUCK_OPEN_MODAL_ACESSO_NEGADO');
export const duckOpenModalUsuarioPendente = createAction('DUCK_OPEN_MODAL_USUARIO_PENDENTE');
export const duckOpenModalCor = createAction('DUCK_OPEN_MODAL_COR');
export const duckSetCaptcha = createAction('DUCK_SET_CAPTCHA');
export const duckSetReloadCaptcha = createAction('DUCK_SET_RELOAD_CAPTCHA');

export const duckDadosMinimizados = createAction('DUCK_DADOS_MINIMIZADOS');

export default createReducer(INITIAL_STATE, {
  [duckChangeLibras.type]: (state, action) => ({
    ...state,
    changeLibras: action.payload,
  }),
  [duckTheme.type]: (state, action) => ({
    ...state,
    theme: action.payload,
  }),
  [duckStatusLoading.type]: (state, action) => ({
    ...state,
    statusLoading: action.payload,
  }),
  [duckStatusLoadingGrid.type]: (state, action) => ({
    ...state,
    statusLoadingGrid: action.payload,
  }),
  [duckAlertApp.type]: (state, action) => ({
    ...state,
    alertApp: action.payload,
  }),
  [duckOpenModal.type]: (state, action) => ({
    ...state,
    modal: action.payload,
  }),
  [duckOpenModalEncaminhar.type]: (state, action) => ({
    ...state,
    modalEncaminhar: action.payload,
  }),
  [duckOpenModalJustificativa.type]: (state, action) => ({
    ...state,
    modalJustificativa: action.payload,
  }),
  [duckOpenModalAcessoNegado.type]: (state, action) => ({
    ...state,
    modalAcessoNegado: action.payload,
  }),
  [duckOpenModalUsuarioPendente.type]: (state, action) => ({
    ...state,
    modalUsuarioPendente: action.payload,
  }),
  [duckOpenModalCor.type]: (state, action) => ({
    ...state,
    modalCor: action.payload,
  }),
  [duckSetReloadCaptcha.type]: (state, action) => ({
    ...state,
    captcha: { reload: action.payload },
  }),
  [duckDadosMinimizados.type]: (state, action) => ({
    ...state,
    dadosMinimizados: action.payload,
  }),
});
